export default "__VITE_ASSET__DHUBmgG4__"